/*
 * All Metals — native cut-to-size dimensions (replaces the DPO + BCPO apps)
 * ---------------------------------------------------------------------------
 * The Custom Width / Custom Length <select>s are rendered by the theme
 * (snippets/cut-to-size-dimensions.liquid) as real line-item property fields
 * bound to the product form, so Shopify itself carries them to the cart and
 * order. This script only does the matching: when either dimension changes it
 * picks the smallest stock sheet the piece genuinely fits inside (either
 * orientation) and selects that variant in the theme's own variant picker,
 * which drives price, weight and shipping exactly as before.
 *
 * Nothing here depends on an app. If this script fails to run the shopper can
 * still submit, and the required attribute on the selects keeps dimensions
 * from being skipped.
 *
 * Add ?ctsdebug=1 to a product URL to watch it in the console.
 */
(function () {
  'use strict';

  var DEBUG = /[?&]ctsdebug=1/.test(window.location.search);
  function log() {
    if (DEBUG && window.console) console.log.apply(console, ['[cut-to-size]'].concat([].slice.call(arguments)));
  }

  /* "24\" (24.00\")" -> 24 ; "24\"-1/8\" (24.125\")" -> 24.125 ; "24.5" -> 24.5 */
  function readInches(value) {
    var s = String(value || '');
    var m = s.match(/\(\s*([0-9]*\.?[0-9]+)/);
    if (m) return parseFloat(m[1]);
    m = s.match(/([0-9]*\.?[0-9]+)/);
    return m ? parseFloat(m[1]) : NaN;
  }

  /* "24\" x 30\", you will receive:" -> {w:24, l:30} */
  function readSheet(title) {
    var m = String(title || '').match(/([0-9]*\.?[0-9]+)\s*"?\s*x\s*([0-9]*\.?[0-9]+)/i);
    return m ? { w: parseFloat(m[1]), l: parseFloat(m[2]) } : null;
  }

  function fits(pw, pl, s) {
    return (pw <= s.w && pl <= s.l) || (pw <= s.l && pl <= s.w);
  }

  function choose(pw, pl, sheets) {
    var best = null;
    for (var i = 0; i < sheets.length; i++) {
      if (!sheets[i].available && sheets[i].available !== undefined) continue;
      if (!fits(pw, pl, sheets[i])) continue;
      var area = sheets[i].w * sheets[i].l;
      if (!best || area < best.area) best = { area: area, sheet: sheets[i] };
    }
    if (best) return { sheet: best.sheet, oversize: false };
    if (!sheets.length) return null;
    var largest = sheets[0];
    for (var j = 1; j < sheets.length; j++) if (sheets[j].w * sheets[j].l > largest.w * largest.l) largest = sheets[j];
    return { sheet: largest, oversize: true };
  }

  /* Select a variant through the theme's own picker so Dawn updates price,
     availability, media and the hidden id input itself. Falls back to writing
     the hidden input directly if no picker control is found. */
  function selectVariant(root, variant) {
    var picker = root.querySelector('variant-selects, variant-radios, .product-form__input, [data-variant-picker]');
    var control = null;
    var wanted = variant.option1;

    var selects = root.querySelectorAll('variant-selects select, variant-radios select, select.select__select');
    for (var i = 0; i < selects.length && !control; i++) {
      var opts = selects[i].options;
      for (var o = 0; o < opts.length; o++) {
        if (opts[o].value === wanted || opts[o].text.trim() === wanted) { control = { el: selects[i], opt: opts[o] }; break; }
      }
    }
    if (control) {
      if (!control.opt.selected) {
        control.el.value = control.opt.value;
        control.el.dispatchEvent(new Event('change', { bubbles: true }));
        log('selected via <select>', wanted);
      }
      return true;
    }

    var radios = root.querySelectorAll('variant-selects input[type="radio"], variant-radios input[type="radio"], fieldset.product-form__input input[type="radio"]');
    for (var r = 0; r < radios.length; r++) {
      if (radios[r].value === wanted) {
        if (!radios[r].checked) {
          radios[r].checked = true;
          radios[r].dispatchEvent(new Event('change', { bubbles: true }));
          log('selected via radio', wanted);
        }
        return true;
      }
    }

    var idInput = root.querySelector('input[name="id"]');
    if (idInput) {
      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      log('selected via hidden id (no picker found)', variant.id);
      return true;
    }
    return false;
  }

  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    if (format && format.indexOf('{{') > -1) return format.replace(/\{\{\s*amount[^}]*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function init(block) {
    if (block.__cts) return;
    block.__cts = true;

    var cfgEl = block.querySelector('script[type="application/json"]');
    var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return log('bad config'); }

    var sheets = [];
    for (var i = 0; i < cfg.variants.length; i++) {
      var s = readSheet(cfg.variants[i].title);
      if (s) { s.id = cfg.variants[i].id; s.option1 = cfg.variants[i].option1; s.price = cfg.variants[i].price; s.available = cfg.variants[i].available; s.title = cfg.variants[i].title; sheets.push(s); }
    }
    if (!sheets.length) return log('no stock sizes parsed from variants');

    var section = block.closest('.shopify-section, section, product-info') || document;
    var widthSel = block.querySelector('select[name="properties[Custom Width]"]');
    var lengthSel = block.querySelector('select[name="properties[Custom Length]"]');
    var status = block.querySelector('[data-cts-status]');
    function mainForm() {
      var forms = section.querySelectorAll('form[action*="/cart/add"]');
      for (var f = 0; f < forms.length; f++) if (forms[f].querySelector('[type="submit"]')) return forms[f];
      return forms[0] || null;
    }
    function submitButton() {
      var f = mainForm();
      return (f && f.querySelector('[type="submit"]')) || section.querySelector('.product-form__submit');
    }
    function dimsComplete() {
      var pw = readInches(widthSel.value), pl = readInches(lengthSel.value);
      return isFinite(pw) && isFinite(pl) && pw > 0 && pl > 0;
    }
    function setSubmitState(enabled) {
      var b = submitButton(); if (!b) return;
      b.disabled = !enabled;
      if (enabled) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', 'true');
    }

    function setStatus(text, warn) {
      if (!status) return;
      status.textContent = text || '';
      status.hidden = !text;
      status.classList.toggle('cut-to-size__status--warn', !!warn);
    }

    function apply(reason) {
      var pw = readInches(widthSel.value), pl = readInches(lengthSel.value);
      if (!isFinite(pw) || !isFinite(pl) || pw <= 0 || pl <= 0) {
        setStatus(cfg.strings.incomplete || '');
        if (cfg.requireDimensions) setSubmitState(false);
        return;
      }
      var c = choose(pw, pl, sheets);
      if (!c) return;
      selectVariant(section, c.sheet);
      setSubmitState(true);
      var label = (cfg.strings.priced_as || 'Priced as a [size] sheet').replace(/\[size\]|\{\{\s*size\s*\}\}/g, c.sheet.w + '" x ' + c.sheet.l + '"');
      if (c.oversize) label = (cfg.strings.oversize || 'Larger than our biggest sheet ([size]). Please contact us for a quote.').replace(/\[size\]|\{\{\s*size\s*\}\}/g, c.sheet.w + '" x ' + c.sheet.l + '"');
      setStatus(label, c.oversize);
      log(reason, pw + '" x ' + pl + '" ->', c.sheet.title, money(c.sheet.price, cfg.moneyFormat));
    }

    widthSel.addEventListener('change', function () { apply('width changed'); });
    lengthSel.addEventListener('change', function () { apply('length changed'); });

    /* Dawn's product form is novalidate and its JS never checks validity, so the
       required attribute alone does not stop an add-to-cart with no dimensions.
       Guard the submit in the capture phase so it runs before the theme's own
       handler, and keep the button state honest if Dawn re-renders it. */
    function guard(event) {
      if (!cfg.requireDimensions || dimsComplete()) return;
      var f = mainForm(); if (!f) return;
      var target = event.target;
      var isOurs = (event.type === 'submit' && target === f) ||
                   (event.type === 'click' && target.closest && target.closest('[type="submit"]') && target.closest('form') === f);
      if (!isOurs) return;
      event.preventDefault(); event.stopImmediatePropagation();
      setStatus(cfg.strings.incomplete || '', true);
      var first = !readInches(widthSel.value) ? widthSel : lengthSel;
      try { first.reportValidity(); } catch (e) {}
      first.focus();
      log('blocked add-to-cart: dimensions incomplete');
    }
    document.addEventListener('submit', guard, true);
    document.addEventListener('click', guard, true);
    /* 11-3-26: the button now renders disabled server-side (buy-buttons.liquid), and Dawn's
       variant-change render copies that attribute back onto the button after every sheet
       match, so re-enable here whenever both dimensions are complete. */
    block.__reapply = function () {
      if (!dimsComplete()) { if (cfg.requireDimensions) setSubmitState(false); return; }
      var c = choose(readInches(widthSel.value), readInches(lengthSel.value), sheets);
      if (c) setSubmitState(true);
    };

    apply('initial');
  }

  function boot() {
    var blocks = document.querySelectorAll('[data-cut-to-size]');
    for (var i = 0; i < blocks.length; i++) init(blocks[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  /* Dawn re-renders the product info section on variant change; re-bind if our block is replaced. */
  var reapplyTimer = null;
  new MutationObserver(function () {
    boot();
    clearTimeout(reapplyTimer);
    reapplyTimer = setTimeout(function () {
      var blocks = document.querySelectorAll('[data-cut-to-size]');
      for (var i = 0; i < blocks.length; i++) if (blocks[i].__reapply) blocks[i].__reapply();
    }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', boot);
})();
